import {
    configureStore,
    // getDefaultMiddleware
} from '@reduxjs/toolkit';
import userReducer from './userSlice';
import transactionReducer from './transactionSlice';
import requestReducer from './requestSlice';
import directDetbitInfoReducer from './directDebitInfoSlice';
import reconnectionInfoReducer from './reconnectionInfoSlice';
import allProductHistoryInfoReducer from './ProductHistoryInfoSlice';

const store = configureStore({
    reducer: {
        user: userReducer,
        transation: transactionReducer,
        requestStarted: requestReducer,
        directDebit: directDetbitInfoReducer,
        reconnectionInfo: reconnectionInfoReducer,
        allProductHistoryInfo: allProductHistoryInfoReducer,
    },
    // middleware: getDefaultMiddleware({
    //     serializableCheck: false
    // }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;